import * as T from '../../../store/types'
import { api } from '../api'
import { post, patch, get, del } from '../../../helpers/api'
import querystring from 'querystring'
import _ from 'lodash'
import Vue from 'vue'

export const addCard = async ({ commit }, payload) => {
  return new Promise(resolve => {
    post(api.AUTOSHIP_CARD, payload).then(response => {
      response.data.new = true
      commit(T.UPDATE_CARD_LIST, response.data)
      commit(T.SHOW_NOTIFICATION, {
        title: 'New card creation',
        message: window.il8n.t('operation.success'),
        type: 'positive',
      })
      resolve(response.data)
    })
  })
}

export const loadCardList = async ({ commit }, query) => {
  let payload = '?' + querystring.stringify(_.pickBy(query, _.identity))
  return new Promise(resolve => {
    get(api.AUTOSHIP_CARD + payload).then(response => {
      commit(T.UPDATE_CARD_LIST, response.data.data)
      resolve(response.data)
    })
  })
}

export const createAutoshipSales = ({ commit, dispatch, getters }, payload) => {
  return new Promise(resolve => {
    post(api.AUTOSHIP_SUBSCRIPTION, payload).then(response => {
      const json = response.data
      commit(T.SET_AUTOSHIP_SUBSCRIPTION_DETAIL, json)
      commit(T.SHOW_NOTIFICATION, {
        title: 'Autoship Creation',
        message: window.il8n.t('operation.success'),
        type: 'positive',
      })
      resolve(response.data)
    })
  })
}

export const getAutoshipListAction = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    get(api.AUTOSHIP_SUBSCRIPTION + query).then(response => {
      const json = response.data
      commit(T.SET_AUTOSHIP_SUBSCRIPTION_LIST, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const unsubscribeAutoship = async ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.AUTOSHIP_SUBSCRIPTION + '/' + id).then(response => {
      commit(T.SHOW_NOTIFICATION, { title: 'Autoship terminated', message: response.success, type: 'positive' })
      resolve(response)
    })
  })
}

export const loadAutoshipSubscriptionDetail = async ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.AUTOSHIP_SUBSCRIPTION + '/' + query).then(response => {
      const json = response.data
      commit(T.SET_AUTOSHIP_SUBSCRIPTION_DETAIL, json)
      resolve(response.data)
    })
  })
}

export const putAutoshipSubscription = ({ commit }, query) => {
  return new Promise(resolve => {
    patch(api.AUTOSHIP_SUBSCRIPTION + '/' + query.subscription_id, query).then(response => {
      const json = response.data
      commit(T.SET_AUTOSHIP_SUBSCRIPTION_DETAIL, json)
      commit(T.SHOW_NOTIFICATION, {
        title: 'Autoship update',
        message: window.il8n.t('operation.success'),
        type: 'positive',
      })
      resolve(response)
    })
  })
}
